// The tool shell is prerendered; the MRZ is built client-side from the form, so
// this route keeps its default client rendering.
export const prerender = true;
